export enum LinkFilterTypes {
  AllLinks = 'ALL',
  AdLinks = 'AD_LINK',
  QrCodeLinks = 'QR_CODE',
  QuickLinks = 'QUICK_LINK',
  WebQuickLinks = 'WEB_QUICK_LINK',
}
